export var Paths;

(function (Paths) {
  Paths["Connect"] = "/me/facebook/connect";
  Paths["Disconnect"] = "/me/facebook/disconnect";
})(Paths || (Paths = {}));